"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockCacheService = void 0;
const minimatch_1 = require("minimatch");
const FeatureRoot_1 = require("../../root/FeatureRoot");
const CacheService_1 = require("../CacheService");
const StubErrorService_1 = require("../stub/StubErrorService");
class MockCacheService extends CacheService_1.CacheService {
    constructor(opts, root) {
        if (root) {
            super(opts, root);
        }
        else {
            const newRoot = new FeatureRoot_1.FeatureRoot({});
            newRoot.deps.services.setErrorService(new StubErrorService_1.StubErrorService(null));
            super(opts, newRoot);
        }
        this.store = {};
    }
    getStore() {
        return 'mock';
    }
    parseEntryValue(key, entry) {
        if (entry && entry.expiresUnix && entry.expiresUnix <= Math.floor(Date.now())) {
            delete this.store[key];
            return null;
        }
        else {
            return entry === null || entry === void 0 ? void 0 : entry.value;
        }
    }
    _clear() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store = {};
        });
    }
    _get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const entry = this.store[key];
            if (entry) {
                return this.parseEntryValue(key, entry);
            }
            else {
                return null;
            }
        });
    }
    _put(key, value, secondsOrOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const seconds = typeof secondsOrOpts === 'number' ? secondsOrOpts : secondsOrOpts === null || secondsOrOpts === void 0 ? void 0 : secondsOrOpts.seconds;
            if (typeof secondsOrOpts !== 'number' && (secondsOrOpts === null || secondsOrOpts === void 0 ? void 0 : secondsOrOpts.ifNotExists)) {
                const existing = this.parseEntryValue(key, this.store[key]);
                if (existing !== null && existing !== undefined) {
                    return false;
                }
            }
            this.store[key] = {
                value,
                expiresUnix: seconds ? Math.floor(Date.now()) + seconds * 1000 : undefined,
            };
            return true;
        });
    }
    _delete(keys) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const key of keys) {
                delete this.store[key];
            }
        });
    }
    _batchGetKeys(keys) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = {};
            for (const key of keys) {
                if (this.store[key]) {
                    const v = this.parseEntryValue(key, this.store[key]);
                    if (v !== null) {
                        result[key] = v;
                    }
                }
            }
            return result;
        });
    }
    batchGetKeysWithGlob(glob) {
        return __awaiter(this, void 0, void 0, function* () {
            const mm = new minimatch_1.Minimatch(glob);
            const matchingKeys = Object.keys(this.store).filter(key => mm.match(key));
            return this.batchGetKeys(matchingKeys);
        });
    }
    _setAdd(key, values, seconds) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const existing = ((_a = this.store[key]) === null || _a === void 0 ? void 0 : _a.value) || [];
            if (Array.isArray(existing)) {
                const lengthBefore = existing.length;
                this.store[key] = {
                    value: [...new Set([...existing, ...values])],
                    expiresUnix: seconds ? Math.floor(Date.now()) + seconds * 1000 : undefined,
                };
                return this.store[key].value.length - lengthBefore;
            }
            else {
                throw new Error('existing is not a set');
            }
        });
    }
    _setRemove(key, values) {
        return __awaiter(this, void 0, void 0, function* () {
            const existing = this.parseEntryValue(key, this.store[key]);
            if (Array.isArray(existing)) {
                const lengthBefore = existing.length;
                this.store[key] = Object.assign(Object.assign({}, this.store[key]), { value: existing.filter(e => !values.some(v => v === e)) });
                return this.store[key].value.length - lengthBefore;
            }
            else {
                throw new Error('existing is not a set');
            }
        });
    }
    _setMembers(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const existing = this.parseEntryValue(key, this.store[key]);
            if (existing === undefined || existing === null || Array.isArray(existing)) {
                return existing || null;
            }
            else {
                throw new Error('existing is not a set');
            }
        });
    }
    _setHas(key, value) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return ((_a = (yield this.setMembers(key))) === null || _a === void 0 ? void 0 : _a.includes(value)) || false;
        });
    }
    _expire(key, seconds) {
        return __awaiter(this, void 0, void 0, function* () {
            this.store[key] = Object.assign(Object.assign({}, this.store[key]), { expiresUnix: Math.floor(Date.now()) + seconds * 1000 });
        });
    }
    _getSecondsRemaining(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const entry = this.store[key];
            if (entry === null || entry === void 0 ? void 0 : entry.expiresUnix) {
                return (entry.expiresUnix - Math.floor(Date.now())) / 1000;
            }
            else {
                return null;
            }
        });
    }
    _increment(key, delta) {
        return __awaiter(this, void 0, void 0, function* () {
            const existing = this.parseEntryValue(key, this.store[key]);
            const newValue = (existing || 0) + delta;
            this.store[key] = Object.assign(Object.assign({}, this.store[key]), { value: newValue });
            return newValue;
        });
    }
}
exports.MockCacheService = MockCacheService;
//# sourceMappingURL=MockCacheService.js.map